import React from "react";
import MainScreen from "../components/MainScreen";

export default function Home(){
	return(
		<div>
			<MainScreen/>
		</div>
	);
}